import React from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Styles from './styles.module.scss'
import {useDispatch, useSelector} from "react-redux";

import {
    // setMatrixSellModalStatus,
    setMatrixSellSuccessModalStatus,
    // setMatrixSellWarningModalStatus
} from "../../store/cabinet/action";
// import cfpIcon from "../../theme/assets/other/ftf_cfp_icon.png";



const CabinetMatrixSellSuccessModal = () => {
    const dispatch = useDispatch();

    const matrixSellSuccessModalStatus = useSelector(store => store.cabinet.matrixSellSuccessModalStatus);

    const closeModal = () =>{
        dispatch(setMatrixSellSuccessModalStatus(false));
    }

    const mainBtnHandler = () =>{
        closeModal();
    }

    return (
        <Popup
            open={matrixSellSuccessModalStatus}
            modal
            nested
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={`${Styles.modalContainer}`}>
                <div className={`${Styles.modalCloseBtn}`} onClick={()=>{closeModal()}}>
                    <div/>
                    <div/>
                </div>
                <div className={`${Styles.modalContentWrap}`}>
                    <div className={`${Styles.modalContentNote}`}>
                        Your tokens are added to the common pool of the new circle,
                        as soon as the circle is completely sold out the money will
                        automatically get to your balance!
                    </div>
                    <div className={`${Styles.ftfBackgroundYellowBtn}`} onClick={mainBtnHandler}>Nice!</div>
                </div>
            </div>
        </Popup>
    );
};

export default CabinetMatrixSellSuccessModal;
